module.exports = __webpack_public_path__ + "static/img/ic_cancel.41bfb401.png";